import { IconOptions } from 'primereact/utils';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const AirSelected = (options: IconOptions) => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...options.iconProps}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.4582 1.53405C16.2267 1.58834 15.9092 1.7685 15.7083 1.95955C15.5621 2.09853 12.4772 5.31208 12.227 5.58598C12.1934 5.6228 11.446 5.38565 7.95157 4.22947C5.62252 3.45883 3.69947 2.82835 3.6781 2.82835C3.65673 2.82835 3.23828 3.22957 2.74815 3.71995L1.85705 4.61155L5.40142 6.79083C7.35083 7.98942 8.9428 8.97969 8.93911 8.99144C8.93545 9.00316 8.13212 9.84676 7.15401 10.8661C5.71356 12.3672 5.36248 12.7163 5.30656 12.7034C5.26857 12.6947 4.75302 12.6091 4.16087 12.5133L3.08422 12.339L2.27251 13.1503C1.75273 13.6697 1.47547 13.9696 1.50171 13.9839C1.52421 13.9962 2.2766 14.2634 3.1737 14.5775C4.07079 14.8917 4.81547 15.1594 4.82851 15.1723C4.84156 15.1853 5.10899 15.9298 5.42279 16.8267C5.73656 17.7236 6.00343 18.4758 6.01581 18.4983C6.03022 18.5246 6.32954 18.2478 6.85029 17.7267L7.6623 16.9141L7.48848 15.8549C7.39288 15.2723 7.30729 14.757 7.29827 14.7098C7.28363 14.6329 7.47336 14.4403 9.13491 12.8457C10.154 11.8676 10.9972 11.0644 11.0087 11.0608C11.0202 11.0571 12.0101 12.6492 13.2086 14.5987L15.3877 18.1432L16.2793 17.2519C16.7698 16.7617 17.1711 16.3432 17.1711 16.3218C17.1711 16.3004 16.5414 14.3799 15.7719 12.0539L14.3727 7.82478L14.7649 7.44489C14.9807 7.23593 15.8227 6.42702 16.6362 5.64733C17.4496 4.86761 18.164 4.15676 18.2237 4.06768C18.4064 3.79508 18.4759 3.57821 18.4944 3.22292C18.5081 2.9588 18.4988 2.86104 18.4414 2.67229C18.2248 1.95911 17.5932 1.49111 16.8596 1.50013C16.7105 1.50199 16.5299 1.51724 16.4582 1.53405Z'
        fill='#27292D'
        fillOpacity='0.8'
      />
    </svg>
  );
};

export default AirSelected;
